import { cn } from 'lib/utils';
import { useTranslation } from 'react-i18next';

export const CanceledLabel = ({ status }: any) => {
    const { t } = useTranslation('translation');
    if (status !== 'CANCELED') return null;
    return (
        <div className={cn('bg-orange-700 text-white px-1 font-medium text-xs h-[20px] leading-5')}>
            {t('filters.canceled').toLowerCase()}
        </div>
    );
};
